/* eslint-disable import/first */
/* We disabled eslint import first for main.js in order to make Vue.use follow import of module */

import Vue from 'vue'
import VueFlashMessage from 'vue-flash-message'
Vue.use(VueFlashMessage)

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import 'bootstrap-css-only/css/bootstrap.min.css'
import 'vue-flash-message/dist/vue-flash-message.min.css'
import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT)

import Vuex from 'vuex'
Vue.use(Vuex)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import Calendar from 'vue-bootstrap4-calendar'
Vue.use(Calendar)

import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry)

import UUID from 'vue-uuid'
Vue.use(UUID)

import Prompt from 'CORE/utils/prompt/prompt'
Vue.use(Prompt)

import App from './app.vue'
import router from './router'
import Axios from 'axios'
import AxiosSetup from '@/utils/AxiosSetup.js'
import VueMoment from 'vue-moment'
Vue.use(VueMoment)

import { Client } from '@stomp/stompjs'
import moment from 'moment'

import errorMessages from 'ENUMS/error-messages'

import '@fortawesome/fontawesome-free/css/all.css'
window.FontAwesomeConfig = { autoReplaceSvg: false }

// pokud je neplatny token tak zahodime celou storage
const token = Vue.$jwt.decode()
try {
    if (moment(token.exp, 'X').isBefore()) {
        localStorage.clear()
        window.location.replace('/app/')
    }
} catch (e) {
    localStorage.clear()
}

const messages = {
    en: require('@/lang/en.json'),
    cs: require('@/lang/cs.json'),
    de: require('@/lang/de.json'),
}

const i18n = new VueI18n({
    messages,
    silentTranslationWarn: true,
})

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    i18nRootKey: 'validations',
    i18n,
    dictionary: {
        en: require('vee-validate/dist/locale/en'),
        cs: require('vee-validate/dist/locale/cs'),
        de: require('vee-validate/dist/locale/de'),
    },
})

import EventBus from 'CORE/bus'
import CoreStoreModules from 'CORE/stores'

import HelpDirective from 'CORE/mixins/help'
Vue.directive('help', HelpDirective)

import { EVENT_USER_CHANGED_LOCALE, EVENT_USER_SET, EVENT_USER_TOKEN_TIMEOUT } from 'CORE/stores/current-user'

Vue.config.productionTip = false

import _ from 'lodash'

_.mixin({
    sortWith: function(arr, sorter) {
        return _.map(arr).sort(sorter)
    },
})

// Axios error handling
Axios.interceptors.response.use(
    r => r,
    e => AxiosSetup.handleError(e)
)

export const store = new Vuex.Store({
    modules: {},
    state: {
        ready: false,
        readyTime: 0,
        apiInfo: {},
        dataLoadIterator: 0,
        stompStatus: 'connecting',
    },
    getters: {
        appReady: state => state.ready,
        readyTime: state => state.readyTime,
        stompStatus: state => state.stompStatus,
        DLI: state => state.dataLoadIterator,
    },
    mutations: {
        appReady: (state, ready) => {
            state.ready = ready
            state.readyTime = Date.now()
        },
        stompStatus: (state, status) => {
            state.stompStatus = status
        },
        incrementDLI: state => {
            state.dataLoadIterator = state.dataLoadIterator + 1
        },
    },
    actions: {
        async appReady({ commit }, ready) {
            commit('appReady', ready)
        },
    },
})

// Dynamicke pridani storu z modulu
for (const [name, module] of CoreStoreModules) {
    store.registerModule(name, module)
}

import EntityQuery from 'CORE/utils/entity-query'
export const entityQuery = new EntityQuery(store)

import { determineStartupLanguage, LANGUAGES } from './modules/core/utils/lang'

EventBus.$on(EVENT_USER_CHANGED_LOCALE, langCode => {
    i18n.locale = langCode
})

store.commit('setLangCode', determineStartupLanguage(LANGUAGES))

export const EVENT_APP_READY = '/appReady'

const loadingWrapper = async dispatchName => {
    EventBus.$emit('loadingStatus', { dispatchName, state: 'started' })
    try {
        await store.dispatch(`${dispatchName}`)
    } catch (e) {
        EventBus.$emit('loadingStatus', { dispatchName, state: 'failed' })
        throw new Error(e)
    }
    EventBus.$emit('loadingStatus', { dispatchName, state: 'finished' })
    return true
}

EventBus.$on(EVENT_USER_SET, async _ => {
    try {
        await Promise.all([
            loadingWrapper('dataTypesLoad'),
            loadingWrapper('propertyTypesLoad'),
            loadingWrapper('projectTypesLoad'),
            loadingWrapper('taskTypesLoad'),
            loadingWrapper('resourceTypesLoad'),
            loadingWrapper('resourceTypeFunctionsLoad'),
            loadingWrapper('projectsLoad'),
            loadingWrapper('tasksLoad'),
            loadingWrapper('resourcesLoad'),
            loadingWrapper('usersLoad'),
            loadingWrapper('commentsLoad'),
            loadingWrapper('attachmentsLoad'),
            loadingWrapper('taskStatesLoad'),
            // loadingWrapper('aclLoad'),
            loadingWrapper('groupsLoad'),
            loadingWrapper('companyTemplatesLoad'),
        ])
        store.commit('appReady', true)
        EventBus.$emit(EVENT_APP_READY)
    } catch (e) {
        console.warn(e)
        store.dispatch('currentUserTokenTimeout')
    }
})

EventBus.$on(EVENT_USER_TOKEN_TIMEOUT, async _ => {
    await store.dispatch('currentUserTokenTimeout')
    router.push('/')
})

// stompj connection
let wsPath = '/ws'
if (window.location.protocol === 'http:') {
    wsPath = `ws://${window.location.host}/ws`
} else {
    wsPath = `wss://${window.location.host}/ws`
}

if (window.location.host === 'localhost:8080') {
    wsPath = 'ws://localhost:15674/ws'
    // wsPath = 'ws://192.168.107.22/ws'
}

let stompConnectionTime = 0

export const stompClient = new Client({
    brokerURL: wsPath,
    connectHeaders: {
        login: 'web',
        passcode: 'web',
        host: 'web',
    },
    reconnectDelay: 300 * 1000,
    heartbeatIncoming: 10 * 1000,
    heartbeatOutgoing: 10 * 1000,
})

stompClient.onConnect = function(frame) {
    EventBus.$emit('STOMP_STATUS', 'connected')
    store.commit('stompStatus', 'connected')
    // console.info('Stomp connected...', stompClient)
    stompConnectionTime = Math.floor(Date.now() / 1000)
    stompClient.subscribe(`/topic/updates`, message => {
        const content = JSON.parse(message.body)
        EventBus.$emit('DATA_UPDATE', content)
    })
    stompClient.subscribe(`/topic/notifications.${store.getters.currentUserId}`, message => {
        try {
            const content = JSON.parse(message.body)
            EventBus.$emit('NOTIFICATION_RECIEVED', content)
        } catch (e) {
            console.warn(e)
        }
    })
    stompClient.subscribe('/topic/locks', message => {
        const content = JSON.parse(message.body)
        store.commit('setLock', content)
    })
}

stompClient.debug = function(str) {
    // console.log('STOMP: ' + str)
}

stompClient.onChangeState = function(state) {
    if (state === 1) {
        console.info(`STOMP state change to ${state}`)
        console.log(`Connection last for ${Math.floor(Date.now() / 1000) - stompConnectionTime}s`)
    }
    stompConnectionTime = Math.floor(Date.now() / 1000)
}

stompClient.onDisconnect = function(frame) {
    EventBus.$emit('STOMP_STATUS', 'disconnected')
    store.commit('stompStatus', 'disconnected')
    // console.log('Stomp disconnect')
    // console.log(`Connection last for ${Math.floor(Date.now() / 1000) - stompConnectionTime}s`)
    stompConnectionTime = Math.floor(Date.now() / 1000)
}

stompClient.onStompError = function(frame) {
    EventBus.$emit('STOMP_STATUS', 'disconnected')
    store.commit('stompStatus', 'disconnected')
    // console.log('Broker reported error: ' + frame.headers['message'])
    // console.log('Additional details: ' + frame.body)
    // console.log(`Connection last for ${Math.floor(Date.now() / 1000) - stompConnectionTime}s`)
    stompConnectionTime = Math.floor(Date.now() / 1000)
}

stompClient.onWebSocketClose = function(frame) {
    // console.info(`ws closed`, frame)
    stompClient.deactivate()
    stompClient.activate()
}

stompClient.onWebSocketError = function(frame) {
    console.info(`ws error`, frame)
}

stompClient.activate()

EventBus.$emit('STOMP_STATUS', 'connecting')
store.commit('stompStatus', 'connecting')

EventBus.$on(EVENT_USER_SET, () => {
    stompClient.subscribe(`/topic/updates`, message => {
        const content = JSON.parse(message.body)
        EventBus.$emit('DATA_UPDATE', content)
    })
    stompClient.subscribe(`/topic/notifications.${store.getters.currentUserId}`, message => {
        try {
            const content = JSON.parse(message.body)
            EventBus.$emit('NOTIFICATION_RECIEVED', content)
        } catch (e) {
            console.warn(e)
        }
    })
    stompClient.subscribe('/topic/locks', message => {
        const content = JSON.parse(message.body)
        store.commit('setLock', content)
    })
})

// for (const t of [1, 2, 3]) {
//     setTimeout(() => {
//         EventBus.$emit('NOTIFICATION_RECIEVED', {
//             title: `Notification title ${t}`,
//             body: 'Notification body which is extra extra eeeeeeeeeeeextra long and complicated but it should be showed somehow.',
//             icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACXUlEQVR4nO2aPWsUURSGj0YLJRBBECyMWAh+JMEgNhGstEoR/RHaCUaUFBaChaYISFSwknTRKikElaQxVYKCKDaKX00gKgQlfieB+F43A7LrzJ3ZnfOeJZ4HnnrPc3YWdvdeEcdxHMdxHC6b4XX4ftUbsNV0IjI34UqVI6YTkfkgtQv4AtdbDqXJNngG3oUfpTY+cR7eg+fhdpNJS2YXvAN/SXp0mktwDO6mT10C6+AF+F2Kh1f7E16CLdSCBtgAb0nj4dWOw03EjroI71L4nJcdnzgBN9Jq6mBQ9OITh2g1BTkIl0V/AeE1DpGaCjEp+vGJk6Sm3HQKLz6xm1KWk6vCX8AwpSwnr4S/gLeUshzsFH58YjuhL8oJsVvAcUJflAGxW8AAoS9K+DPDagHXCH1RbovdAkYJfVHCjxSrBYwR+qLcF7sFPCD0RZkSuwU81M+L80jsFjBD6IvyXOwW8IzQF+W12C3gJaEvymexW8A8oS+TNrGLT2xTr8zgQMpQTLvUKzPoSxmKaZ96ZQZXUoZielm9MoOZlKGYTqtXprBFKsdX1gtYWp2FTn8dw2rZr9xaQzjGtvwCVG34f5B6dnhWIaJRz6kW/8V+KefUt2x/wA7F7j/sgO+MQ7OclcqdBBX2wDdNEBkzvEH7yo4/Cj81QVxeF2BvWfEn4WITRBU1nCKfLmsJjtMYe+GpgnaaTKrEYSn+GT5mMqkS4drcU8kf/0LW4K3RcIfom8Tjwze6HqMZ1TkC5yQ9PlyjXVOP/r8Iv93DLdLH8KtUnoon8CLcajiX4ziO4zj/Gb8BC5G6ebDIvyEAAAAASUVORK5CYII=',
//             requireInteraction: false,
//             type: 'error',
//             onclick: {
//                 externalUrl: 'https://google.com',
//             },
//         })
//     }, t * 1000)
// }

EventBus.$on('DATA_UPDATE', async content => {
    const entityType = _.get(content, 'entity_type')
    const entityId = _.get(content, 'entity_id')
    switch (entityType) {
        case 'project':
            await store.dispatch('loadProject', entityId)
            await store.commit('incrementDLI')
            break
        case 'comment':
            await store.dispatch('commentsLoad')
            await store.commit('incrementDLI')
            break
    }
})

setInterval(() => store.commit('lockTTLTick'), 1000)

setInterval(() => {
    _.forEach(store.getters.getAllLocks, (v, k) => {
        const data = { user: store.getters.currentUserId, entity: k, type: 'info' }
        stompClient.publish({
            destination: '/queue/task.locking',
            body: JSON.stringify(data),
            headers: { 'priority': '9', 'content-type': 'application/json' },
        })
    })
}, 30000)

/**
 * fce pro nastartovani a nastaveni aplikace po nacteni
 */
async function startupAppSetup() {
    await store.dispatch('apiInfoLoad')
    return Promise.all([store.dispatch('currentUserCheck')])
}

import { DATE_TIME_FORMAT } from 'CORE/utils/date'

Vue.filter('formatTimestamp', timestamp => {
    if (timestamp === null) {
        return null
    }
    return moment(timestamp, 'X').format(DATE_TIME_FORMAT)
})

document.addEventListener('DOMContentLoaded', function() {
    return new Vue({
        el: '#app',
        router,
        i18n,
        store,
        async mounted() {
            window.Vue = this
            await startupAppSetup()
            EventBus.$on('FLASH_OK', async msg => {
                const message = _.get(msg, 'message', 'Ok')
                this.flash(`<strong>${message}</strong>`, 'success', { timeout: 2000 })
            })
            EventBus.$on('FLASH_USER_ERROR', async msg => {
                const message = _.get(msg, 'message', 'Ok')
                this.flash(`<strong>Chyba:</strong> ${message}`, 'error', { timeout: 10000 })
            })
            EventBus.$on('FLASH_ERROR', async error => {
                const response = _.get(error, 'response', {})
                const statusCode = _.get(response, 'status', 200)
                const errorMessage = _.get(response, 'data.message', 'NO_MESSAGE')
                const flashMessage = _.get(
                    errorMessages,
                    `[${statusCode}][${errorMessage}]`,
                    'Chyba při zpracování požadavku'
                )
                this.flash(
                    `<strong>${flashMessage}</strong><br />
                    <div style="font-size: 70%; text-align: center; font-style: italic;">(HTTP/${statusCode}/${errorMessage})</div>`,
                    'error',
                    {
                        timeout: 10000,
                    }
                )
            })
            EventBus.$on('FLASH_INFO', async msg => {
                const message = _.get(msg, 'message', 'Ok')
                this.flash(`<strong>Info:</strong> ${message}`, 'info', { timeout: 20000 })
            })
        },
        render: h => h(App),
    })
})
